<div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-bg-background">
  <div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-flex tw-flex-col tw-justify-center tw-items-center">
    <div class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4">
      <div (click)="goBack()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-full tw-cursor-pointer tw-p-2 tw-mb-10">
        <div class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
          <img class="tw-w-6 tw-h-6 tw-object-contain" src="../../../assets/arrow-left.svg" />
        </div>
        <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-px-5">{{ "back" | translate }}</p>
      </div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "login" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "email" | translate }}</p>
        <input
          class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
          type="email"
          [(ngModel)]="email"
          (change)="setEmail($event)"
          [placeholder]="'email-placeholder' | translate"
        />
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "password" | translate }}</p>
        <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
          <input
            class="tw-w-full tw-h-full tw-bg-white tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
            [type]="inputType1"
            [(ngModel)]="password"
            (change)="setPassword($event)"
            placeholder="{{ 'enter-your-password' | translate }}"
          />
          <img (click)="showHideField(1)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide1" />
        </div>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
          {{ isErrorText | translate }}
        </p>
        <p (click)="goToForgotPassword()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-primary tw-text-right tw-cursor-pointer tw-mb-6">
          {{ "forgot-password-2" | translate }}
        </p>
        <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-6 tw-mb-6">
          <button (click)="login()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm tw-bg-primary tw-text-secondary tw-rounded-[5px] tw-py-3">{{ "login" | translate }}</button>
        </div>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-text-center tw-mb-10 md:tw-mb-20">
          {{ "not-registered-yet" | translate }}
          <span (click)="goToRegister()" class="tw-text-primary tw-cursor-pointer">{{ "create-an-account" | translate }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
